import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

type SkeletonColumn = { key: string; size: number };

const LEAD_SKELETON_COLUMNS: SkeletonColumn[] = [
  { key: 'full_name', size: 240 },
  { key: 'job_title', size: 160 },
  { key: 'company_name', size: 220 },
  { key: 'emails', size: 180 },
  { key: 'phones', size: 180 },
  { key: 'actions', size: 140 },
  { key: 'department', size: 160 },
  { key: 'social_link', size: 164 },
  { key: 'total_experience', size: 190 },
  { key: 'education_degrees', size: 200 },
  { key: 'tags', size: 160 },
  { key: 'lists', size: 160 },
  { key: 'row_actions', size: 46 },
];

const COMPANY_SKELETON_COLUMNS: SkeletonColumn[] = [
  { key: 'company_name', size: 250 },
  { key: 'actions', size: 212 },
  { key: 'socials', size: 152 },
  { key: 'hq_location', size: 200 },
  { key: 'founded_year', size: 120 },
  { key: 'industry', size: 160 },
  { key: 'type', size: 120 },
  { key: 'is_b2b', size: 100 },
  { key: 'sic_codes', size: 150 },
  { key: 'naics_codes', size: 150 },
  { key: 'employee_count', size: 130 },
  { key: 'list', size: 160 },
  { key: 'tags', size: 160 },
  { key: 'row_actions', size: 46 },
];

const SKELETON_ROWS = 6;

type Props = { tab: 'leads' | 'companies' };

const TableLoadingSkeleton: React.FC<Props> = ({ tab }) => {
  const columns =
    tab === 'leads' ? LEAD_SKELETON_COLUMNS : COMPANY_SKELETON_COLUMNS;
  return (
    <div className="tanstack-table">
      <div className="tanstack-table--wrapper">
        <div className="tanstack-table--table">
          <div className="tanstack-table--thead">
            <div className="tanstack-table--tr">
              {columns.map((col) => (
                <div
                  key={col.key}
                  className="tanstack-table--th"
                  style={{ width: col.size, minWidth: col.size }}
                >
                  <div className="column-header-content loading">
                    <SkeletonLoading width={100} height={20} />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="tanstack-table--tbody">
            {Array.from({ length: SKELETON_ROWS }).map((_, rowIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={rowIndex} className="tanstack-table--tr">
                {columns.map((col) => (
                  <div
                    key={col.key}
                    className="tanstack-table--td"
                    style={{ width: col.size, minWidth: col.size }}
                  >
                    <div className="column-cell-content loading">
                      <SkeletonLoading width={100} height={18} />
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableLoadingSkeleton;
